import { render, staticRenderFns } from "./MobilePhoneCreate.vue?vue&type=template&id=fb5e2d36&scoped=true&"
import script from "./MobilePhoneCreate.vue?vue&type=script&lang=js&"
export * from "./MobilePhoneCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePhoneCreate.vue?vue&type=style&index=0&id=fb5e2d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5e2d36",
  null
  
)

/* custom blocks */
import block0 from "./MobilePhoneCreate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports